import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import PdfViewer from '../../../../module/pdf/PdfViewer'
import { alertActions, authActions, contracterActions, efdocActions, modalActions, certboxActions } from '../../../../store/actions'

const EfDocumentList = (props) => {
  const [checkedbox, setCheckedbox] = useState(new Set())
  const checkedboxRef = useRef(checkedbox)

  const [canSubmit, setCanSubmit] = useState(false) //제출버튼 표시 여부
  const [canAccept, setCanAccept] = useState(false) //수취 버튼 표시 여부
  const [canReject, setCanReject] = useState(false) //반려 버튼 표시 여부
  const [canDelete, setCanDelete] = useState(false) //삭제 버튼 표시 여부
  const [isShowPdf, setIsShowPdf] = useState(false) //pdf버튼 버튼 표시 여부

  const [active, setActive] = useState()

  const canShowEdit = useRef(() => {
    return checkedboxRef.current.size && (canSubmit || canAccept || canReject || canDelete)
  })

  const [showEdit, setShowEdit] = useState() //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23

  const [contAllCheck, setContAllCheck] = useState(false)
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()

  const tabIdRef = useRef()
  useEffect(() => {
    if (props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
      setCheckedbox(new Set())
      checkedboxRef.current.clear()
      setContAllCheck(false)
      setShowEdit(false)
    }
  }, [props.tabId])

  useEffect(() => {
    if (props.isSubmit) {
      handleAllCheck(false)
    }
  }, [props.isSubmit])

  useEffect(() => {
    let type = ''
    if (props.isDelete || props.isDelete2) {
      // 수신함 삭제 성공
      type = '삭제'
    } else if (props.isReject) {
      // 수신함 반려신청 성공
      type = '반려'
    } else if (props.isReceive) {
      // 수취완료 성공
      // type = "수취완료";
      type = '읽음'
    } else {
      return // 에러처리 전까진 그냥 리턴시킴
    }

    props.success({
      title: type + '성공',
      message: type + '되었습니다.',
      params: {
        type: 'success',
        callback: () => {
          window.location.reload()
          // props.readInboxList();
        },
      },
    })
  }, [props.isDelete, props.isDelete2, props.isReject, props.isReceive])

  useEffect(() => {
    const fileList = props.CertboxInfo?.fileList

    if (!fileList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return
    }
  }, [props.CertboxInfo])

  const makeStatusBtn = (status) => {
    switch (status) {
      case '03':
        return <span className="text-blue">발급완료</span>
        break
      case '01':
        return <span className="text-gray">임시저장</span>
        break
      case '02':
        return <span className="text-black">전송완료</span>
        break
      case '04':
        return <span className="text-black">오류통보</span>
        break
      case '10':
        return <span className="text-red">안 읽음</span>
        break
      case '11':
        return <span className="text-red">반려</span>
        break
      case '12':
        return <span className="text-green">읽음</span>
        break
      default:
        return <span className="text-black">상태미정{status}</span>
    }
  }

  const onCertboxSubmit = () => {
    props.onCertboxSubmit(Array.from(checkedboxRef.current), Array.from(props.orgdata))
  }

  const getChecked = () => {
    let checkedCrtSeqSet = new Set()
    let checkedRcvCrtSeqSet = new Set()
    for (let obj of checkedboxRef.current) {
      checkedCrtSeqSet.add(obj.crtSeq)
      checkedRcvCrtSeqSet.add(obj.crtRcvSeq)
    }
    let checkedCrtSeqArr = Array.from(checkedCrtSeqSet)
    let checkedRcvCrtSeqArr = Array.from(checkedRcvCrtSeqSet)
    return {
      checkedCrtSeq: checkedCrtSeqArr,
      checkedRcvCrtSeq: checkedRcvCrtSeqArr,
    }
  }

  // 조건 단건 변경시
  const onSelected = (e, type, value) => {
    let changedObj = {
      type: type,
      value: value,
    }
    props.changeSearchInfo(changedObj)
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDownOld = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        if (idx === 1) {
          let url = process.env.REACT_APP_API_URL + '/portal/file/general/' + fileList[idx].encryptedId
          let xhr = new XMLHttpRequest()
          xhr.responseType = 'blob'
          xhr.onload = function () {
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('Y')
            setFileId(fileList[idx].fileId)
            setPrintYn('N')
          }
          xhr.open('GET', url)
          xhr.send()
        }
      }, 20)
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }

  /**
   * @param {String} stsCd
   * @returns 선택된 계약 중에 해당 sts 인 것이 존재하는지 여부
   */
  let hasChecked = (stsCd) => {
    for (let obj of checkedboxRef.current) {
      if (obj.sts === stsCd) {
        return true
      }
      return false
    }
  }

  /**
   * @param {Array} stsCdArr
   * @returns 일치하는 거 하나라도 선택되었으면 true
   */
  let hasAnyChecked = (stsCdArr) => {
    for (let obj of checkedboxRef.current) {
      if (stsCdArr.includes(obj.sts)) {
        return true
      }
    }
    return false
  }

  /**
   * @param {Array} stsCdArr
   * @returns 일치하는 거 하나라도 선택되었으면 false
   */
  let hasNoneChecked = (stsCdArr) => {
    for (let obj of checkedboxRef.current) {
      if (stsCdArr.includes(obj.sts)) {
        return false
      }
    }
    return true
  }

  const stsLiteral = {
    임시저장: '01',
    전송완료: '02',
    발급완료: '03',
    오류통보: '04',

    제출: '10',
    반려: '11',
    수취완료: '12',
    회수: '13',
  }

  //복수 제어 함수
  const changeShowForm = () => {
    setShowEdit(checkedboxRef.current.size)
    const sts = stsLiteral

    //제출버튼 표시할 지 여부
    let bShowSubmit = false
    bShowSubmit = hasChecked(sts.발급완료) //발급완료 상태가 포함
    // 다음 건들이 선택되었을 경우 표시 안 함
    // 임시저장, 전송완료는 발급완료 전단계로 생각됨.
    // 제출, 수취완료 건은 중복 제출을 막음.
    // 오류통보, 반려, 회수 건은 수정해서 다시 제출하는 게 맞을 거라 생각됨
    bShowSubmit = bShowSubmit && hasNoneChecked([sts.임시저장, sts.전송완료, sts.제출, sts.수취완료])
    setCanSubmit(bShowSubmit)

    //수취 버튼 표시할지 여부
    let bShowAccept = false
    bShowAccept = hasChecked(sts.제출)
    setCanAccept(bShowAccept)

    //반려 버튼 표시할지 여부
    let bShowReject = false
    bShowReject = hasChecked(sts.제출)
    setCanReject(bShowReject)

    //삭제 버튼 표시할지 여부
    let bShowDelete = false
    bShowDelete = hasChecked(sts.임시저장)
    setCanDelete(bShowDelete)
  }

  const handleAllCheck = (target, checked) => {
    setContAllCheck(checked)
    if (checked) {
      props.data.forEach((item) => checkedboxRef.current.add(item))
    } else {
      checkedboxRef.current.clear()
    }
    setCheckedbox(checkedboxRef.current)
    changeShowForm()
  }

  const checkedItemHandler = (id, isChecked, crtSeq, sts, crtRcvSeq, obj) => {
    if (isChecked) {
      checkedboxRef.current.add(obj)
    } else {
      for (let cont of checkedboxRef.current) {
        if (obj === cont) {
          checkedboxRef.current.delete(cont)
        }
      }
    }
    setCheckedbox(checkedboxRef.current)
    changeShowForm()
  }

  const checkHandler = ({ target }, certbox) => {
    checkedItemHandler(target.id, target.checked, certbox.crtSeq, certbox.sts, certbox.crtRcvSeq, certbox)
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    setActive(crtSeq)
  }

  return (
    <>
      <div className="list-header">
        <span className="total-num">
          현재페이지 <em>{props.pagingInfo?.currentPage}</em>/{props.pagingInfo?.totalPage} {props.pagingInfo?.totalRecords}건
        </span>
      </div>
      <div className="tbl-wrap mt20">
        <table className="tbl-list">
          <caption>선택, 신청방법, 증명서 및 발급번호, 발급처, 발급일시, 최종이력, 열람 항목으로 구성</caption>
          <colgroup>
            {/* <col style={{ width: '5%' }} /> */}
            <col style={{ width: '10%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '14%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              {/* <th scope="col">선택</th> */}
              <th scope="col">신청방법</th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'DOCID')
                  }}
                >
                  증명서 및 발급번호
                </a>
              </th>
              <th scope="col">발급처</th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'ISSUEDT')
                  }}
                >
                  발급일시
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'MOD_DT')
                  }}
                >
                  최종이력
                </a>
              </th>
              <th scope="col">보관연한</th>
              <th scope="col">열람</th>
              <th scope="col">공전소 Key</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((certboxObj, index) => (
                <tr key={index}>
                  {/* <td>
                    <input
                      type="checkbox"
                      id={`${'row-' + certboxObj.crtSeq + index}`}
                      onChange={(e) => checkHandler(e, certboxObj)}
                      checked={checkedboxRef.current.has(certboxObj)}
                    />
                    <em></em>
                  </td> */}
                  <td>{certboxObj.docType}</td>
                  <td>
                    {certboxObj.crtNm} <span className="txt1">{certboxObj.docid}</span>
                  </td>
                  <td>{certboxObj?.crtCd === '01' ? '-' : certboxObj?.prchsNm}</td>
                  <td>{certboxObj.issuedt === null ? '-' : moment(certboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}</td>
                  <td>{certboxObj.modDt === null ? '-' : moment(certboxObj.modDt).format('YYYY.MM.DD HH:mm:ss')}</td>
                  <td>
                    {certboxObj.fileNewList?.map((fileObj, index) => (
                        fileObj.expiredOn === 'null' ? '-' : moment(fileObj.expiredOn).format('YYYY.MM.DD HH:mm:ss')
                    ))}<br />
                  </td>
                  <td>
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <a
                            key={index}
                            href="#"
                            className="attach attach-link"
                            onClick={(e) => {
                              e.preventDefault()
                              onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                              return
                            }}
                          >
                            첨부
                          </a>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        <a
                          href="#"
                          className="attach attach-link"
                          onClick={(e) => eventHandler(e, certboxObj.crtSeq + index)}
                          aria-expanded={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                          aria-controls={certboxObj.crtSeq + index}
                          aria-disabled={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                        >
                          첨부
                        </a>
                        <ul
                          id={certboxObj.crtSeq + index}
                          className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                        >
                          {certboxObj.fileNewList?.map((fileObj, index) => (
                            <li key={index}>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault()
                                  onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                                  return
                                }}
                              >
                                {fileObj.originFileNm}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {certboxObj.fileGroupId === null && '-'}
                  </td>
                  <td>
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <span className="txt1" key={index}>
                            {fileObj.publicEdms === 'null' ? '-' : fileObj.publicEdms}
                          </span>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <span className="txt1" key={index}>
                            {fileObj.publicEdms === 'null' ? '-' : fileObj.publicEdms}
                          </span>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId === null && '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={9}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxInfo: state.certbox?.certboxInfo,
    isDelete: state.certbox?.isDelete,
    isDelete2: state.contracter?.isDelete,
    isReject: state.certbox?.isReject,
    isSubmit: state.certbox?.isSubmit,
    isReceive: state.certbox?.isReceive,
  }
}

const actionCreators = {
  getcertboxInfo: efdocActions.getcertboxInfo,
  changeSearchInfo: efdocActions.changeSearchInfo,
  getDownLoad: certboxActions.getDownLoad,
  deletecertboxList: efdocActions.deletecertboxList,
  rejectcertbox: efdocActions.rejectcertbox,
  readcertboxList: efdocActions.readcertboxList,
  receivecertbox: efdocActions.receivecertbox,
  deleteTempDoc: contracterActions.deleteTempDoc,
  success: alertActions.success,
  confirm: alertActions.confirm,
  error: alertActions.error,

  showModalBagic: modalActions.showModalBagic,
  clearModal: modalActions.clearModal,
}

export default connect(mapStateToProps, actionCreators)(EfDocumentList)
